import { Icon } from "@zapier/zinnia-icons";
import { useInterfacesTheme } from "lib/theme/ThemeProvider";
import { cn } from "utils/cn";

export const ZeroState = (props: { title: string; subtitle?: string }) => {
  const interfacesTheme = useInterfacesTheme();
  return (
    <div className="flex flex-col items-center p-8">
      <span
        className={cn("flex h-20 w-20 items-center justify-center", {
          "rounded-[50%] bg-zi-lightGray": !interfacesTheme,
          "rounded-large bg-muted text-muted-foreground": interfacesTheme,
        })}
      >
        <Icon size={40} name="navAIChatbot" color="currentColor" />
      </span>
      <div className="text-center">
        <h4 className="mt-5 text-[20px] font-semibold leading-[1.3]">
          {props.title}
        </h4>
        {props.subtitle ? (
          <p
            className={cn("mt-[15px] text-[15px] leading-[1.5]", {
              "text-zi-secondaryText": !interfacesTheme,
              "text-foreground-subtle": interfacesTheme,
            })}
          >
            {props.subtitle}
          </p>
        ) : null}
      </div>
    </div>
  );
};
